<template>
  <div class="chart-map">
    <v-card class="pa-2">
      <v-card-title>Kolkata Wards Map</v-card-title>
      <v-card-subtitle>Total Infected: {{ population }}</v-card-subtitle>
      <v-card-text ref="box" class="pa-0">
        <v-row>
          <v-col cols="12" sm="9">
            <div id="ward-map" ref="ward_map" style="width:100%;">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="100%"
                :height="borders.height"
                viewBox="0 0 807 745"
                enable-background="new 0 0 807 745"
                xml:space="preserve"
              >
                <template v-for="path in paths">
                  <path
                    :key="path.key"
                    :id="path.id"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    :fill="path.highlight"
                    :stroke="path.stroke"
                    :stroke-width="path.strokeWidth"
                    stroke-miterlimit="10"
                    :d="path.path"
                    @click="set_ward(path)"
                  />
                </template>
              </svg>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <v-card width="100%" class="elevation-2">
              <v-card-title class="py-1">Legend</v-card-title>
              <v-card-text style="width:100%; padding: 0">
                <v-list>
                  <v-list-item v-for="item in legend" :key="item.color" style="min-height: 24px">
                    <v-list-item-avatar
                      size="16"
                      :color="item.color"
                      style="margin-top:2px; margin-bottom:2px;"
                    ></v-list-item-avatar>
                    <v-list-item-content style="padding-top:2px; padding-bottom:2px;">
                      <v-list-item-subtitle
                        style="padding-top:2px; padding-bottom:2px;"
                      >{{item.text}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
            <v-card v-if="ward" width="100%" class="elevation-2">
              <v-card-title>Ward {{ward.key}}</v-card-title>
              <v-card-subtitle>Infected {{infected[ward.key] | fix}}</v-card-subtitle>
              <v-card-text class="pa-0">
                <div
                  id="ward-map"
                  ref="ward_map"
                  style="width:75%; margin-left: auto; margin-right: auto; padding: 0"
                >
                  <svg
                    version="1.1"
                    id="ward_inset"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="100%"
                    height="128"
                    :viewBox="bbox"
                    enable-background="new 0 0 807 745"
                    xml:space="preserve"
                  >
                    <path
                      :id="`inset-${ward.id}`"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      :fill="ward.color"
                      stroke="#000000"
                      stroke-width="1%"
                      stroke-miterlimit="10"
                      :d="ward.path"
                    />
                  </svg>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="8">
            <v-slider
              v-model="T"
              :max="max"
              :min="min"
              :step="step"
              label="Transmissibility, T"
              thumb-label="always"
            ></v-slider>
          </v-col>
          <v-col cols="4">
            <v-btn icon outlined @click="operate"><v-icon>{{play_pause}}</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
const wards = require("@/data/paths.json");
const infection = require("@/data/infection.json");
export default {
  data() {
    return {
      T: 0.08,
      min: 0.020,
      max: 0.200,
      step: 0.001,
      width: 752,
      ward: null,
      legend: [
        { color: "#3F7F93", min: 0, max: 1, text: "None" },
        { color: "#7BA7B5", min: 1, max: 10, text: "< 10" },
        { color: "#B8D1D9", min: 10, max: 100, text: "10 - 100" },
        { color: "#E8C0B5", min: 100, max: 1000, text: "100 - 1,000" },
        { color: "#D58A76", min: 1000, max: 10000, text: "1,000 - 10,000" },
        { color: "#C25539", min: 10000, max: 1000000, text: "> 10,000" }
      ],
      play_state: false,
      play_pause: 'mdi-play'
    };
  },

  computed: {
    borders() {
      const width = this.width;
      const height = (690 / 752) * width;
      const boxWidth = (807 / 752) * width;
      const boxHeight = (745 / 752) * width;
      return {
        width: width,
        height: height,
        viewBox: `0 0 ${boxWidth} ${boxHeight}`,
        enableBackground: "new 0 0 ${boxWidth} ${boxHeight}"
      };
    },

    paths() {
      let W = wards;
      let key = this.ward ? this.ward.key : null;
      W.forEach(w => {
        w.color = this.colors[w.key];
        w.highlight = w.key == key ? "#CFA255" : this.colors[w.key];
        w.stroke = w.key == key ? "#995D12" : "#000000";
        w.strokeWidth = w.key == key ? 4 : 1;
      });
      return W;
    },

    bbox() {
      const u = document.getElementById(this.ward.id).getBBox();

      return `${u.x - 0.025 * u.width} ${u.y} ${1.05 * u.width} ${1.05 *
        u.height}`;
    },

    infected() {
      const t = Number(this.T).toFixed(3)
      return infection[t];
    },

    colors() {
      let c = {};
      Object.keys(this.infected).forEach(w => {
        c[w] = this.color(this.infected[w]);
      });
      return c;
    },

    population() {
      let p = Object.values(this.infected).reduce((s, x) => s + x, 0);
      p = 1000 * Math.round(p / 1000);
      return p.toFixed(0);
    }
  },

  methods: {
    color(people) {
      if (people < 1) {
        return "#3F7F93";
      } else if (people < 10) {
        return "#7BA7B5";
      } else if (people < 100) {
        return "#B8D1D9";
      } else if (people < 1000) {
        return "#E8C0B5";
      } else if (people < 10000) {
        return "#D58A76";
      } else {
        return "#C25539";
      }
    },

    set_ward($event) {
      if (this.ward == $event) {
        this.ward = null;
      } else {
        this.ward = $event;
      }
    },

    operate() {
      let steps = 0
      if (this.play_state) {
        this.play_state = false
        this.play_pause = "mdi-play"
      } else {
        this.play_state = true
        this.play_pause = "mdi-pause"
        this.T = 0.02
        let timer = window.setInterval(() => {
          if ((this.T >= 0.200) || (!this.play_state)) {
            this.play_state = false
            this.play_pause = "mdi-play"
            window.clearInterval(timer)
          } else {
            this.T = this.T + 0.001
            steps++
          }
        }, 100)
      }
    }
  },

  filters: {
    fix(value) {
      let digits = 1;
      if (value < 10) {
        return 1;
      } else if (value < 100) {
        digits = 10;
      } else if (value < 1000) {
        digits = 10;
      } else {
        digits = 100;
      }
      let p = digits * Math.round(value / digits);
      return p.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }
  },

  mounted() {
    this.width = this.$refs.ward_map.offsetWidth;
  }
};
</script>